import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { downloadCsv, type CsvRow } from "./chart-dates";

const fieldClass =
  "h-9 rounded-md border border-slate-200 bg-white px-2 text-sm text-slate-700";

export function StartEndDates({
  from,
  to,
  onFrom,
  onTo,
}: {
  from: string;
  to: string;
  onFrom: (value: string) => void;
  onTo: (value: string) => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <label className="flex items-center gap-2 text-sm text-slate-600">
        Start
        <input
          type="date"
          value={from}
          max={to || undefined}
          onChange={(event) => onFrom(event.target.value)}
          className={fieldClass}
        />
      </label>
      <label className="flex items-center gap-2 text-sm text-slate-600">
        End
        <input
          type="date"
          value={to}
          min={from || undefined}
          onChange={(event) => onTo(event.target.value)}
          className={fieldClass}
        />
      </label>
    </div>
  );
}

export function ChartExportButton({
  filename,
  rows,
}: {
  filename: string;
  rows: CsvRow[];
}) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="h-9 shrink-0 bg-white"
      disabled={rows.length === 0}
      onClick={() => downloadCsv(filename, rows)}
    >
      <Download className="mr-1.5 h-3.5 w-3.5" />
      Export
    </Button>
  );
}
